import React from 'react'
import { compose } from 'redux'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Container } from 'reactstrap'
import styled from 'styled-components'

import {
  MainPage,
  InteractionsPage,
  ContractsPage,
  TransactionsPage
} from '../containers/Pages/Dashboard'

import {
  withDetectComponentSize,
  withAuth,
  withInitialization
} from '../containers/HOC'

const StyledBackgroundWrapper = styled.div`
  background-color: #f6f6f6;
  /* min-height: 100vh; */
`

const Routes = () => {
  return (
    <StyledBackgroundWrapper>
      <Container>
        <Switch>
          <Route path="/dashboard/contracts" component={ContractsPage} />
          <Route path="/dashboard/interactions" component={InteractionsPage} />
          <Route
            path="/dashboard/transactions/:propertyId/:productId"
            component={TransactionsPage}
          />
          <Route path="/dashboard/main" component={MainPage} />
          <Route path="*" render={() => <Redirect to="/dashboard/main" />} />
        </Switch>
      </Container>
    </StyledBackgroundWrapper>
  )
}

export default compose(
  withAuth,
  withDetectComponentSize('app'),
  withInitialization
)(Routes)
